module.exports = __webpack_public_path__ + "img/wetzlar.94e75309.svg";